/** Logging with a module prefix. Debug lines only show in development builds. */
type Level = 'debug' | 'info' | 'warn' | 'error';

const DEV = import.meta.env.DEV;

function write(level: Level, prefix: string, args: unknown[]): void {
  if (level === 'debug' && !DEV) return;
  const line = `[${prefix}]`;
  if (level === 'error') console.error(line, ...args);
  else if (level === 'warn') console.warn(line, ...args);
  else if (level === 'info') console.info(line, ...args);
  else console.debug(line, ...args);
}

export interface Logger {
  debug(...args: unknown[]): void;
  info(...args: unknown[]): void;
  warn(...args: unknown[]): void;
  error(...args: unknown[]): void;
}

export function logger(prefix: string): Logger {
  return {
    debug: (...args) => write('debug', prefix, args),
    info: (...args) => write('info', prefix, args),
    warn: (...args) => write('warn', prefix, args),
    error: (...args) => write('error', prefix, args),
  };
}
